export default "__VITE_ASSET__Ui6Bssb9__"